export type ThemePreference = "system" | "light" | "dark";
export type Theme = "light" | "dark";

export const THEME_STORAGE_KEY = "theme";

/** Inline script injected during SSR to prevent theme flash before hydration. */
export const THEME_INIT_SCRIPT = `
(function () {
  try {
    var pref = localStorage.getItem("theme");
    var resolved;
    if (pref === "light" || pref === "dark") {
      resolved = pref;
    } else {
      resolved = window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }
    var root = document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(resolved);
    root.style.colorScheme = resolved;
  } catch (e) {}
})();
`.trim();

/** Stable SSR default — must match ThemeProvider pre-mount value to avoid hydration mismatch. */
export const SSR_THEME: Theme = "light";

export function getSystemTheme(): Theme {
  if (typeof window === "undefined") {
    return SSR_THEME;
  }

  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function resolveTheme(
  preference: ThemePreference | string | null | undefined
): Theme {
  if (preference === "light" || preference === "dark") {
    return preference;
  }

  return getSystemTheme();
}

export function readStoredPreference(): ThemePreference {
  if (typeof window === "undefined") {
    return "system";
  }

  const stored = localStorage.getItem(THEME_STORAGE_KEY);

  if (stored === "light" || stored === "dark" || stored === "system") {
    return stored;
  }

  return "system";
}

export function applyTheme(theme: Theme) {
  const root = document.documentElement;
  root.classList.remove("light", "dark");
  root.classList.add(theme);
  root.style.colorScheme = theme;
}

export function persistPreference(preference: ThemePreference) {
  localStorage.setItem(THEME_STORAGE_KEY, preference);
}
